module.exports = __webpack_public_path__ + "img/ods_ES_CA.49f2fb9e.png";